import { Box, Tab, Tabs } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { NAV } from '~/components/Charts/chrome/chartChrome'

const tabs = [
  { path: 'theming', label: NAV.theming },
  { path: 'password', label: NAV.password },
]

export function AccountIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const current = tabs.findIndex((t) => location.pathname.endsWith(t.path))
  return (
    <Box>
      <Tabs value={current >= 0 ? current : 0} onChange={(_, i: number) => navigate(tabs[i]!.path)}>
        {tabs.map((t) => (
          <Tab key={t.path} label={t.label} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  )
}
